import BasketDesktop from 'components/InlineBasket/BasketDesktop/BasketDesktop';
import withBasketDesktopProps from 'viewModel/inlineBasket/basketDesktop/withBasketDesktopProps';

export default withBasketDesktopProps(BasketDesktop);
